// Background pre-compile the game WASM module so that when the user opens a
// game the only remaining work is `WebAssembly.instantiate(module, importObject)`.
// Stashes a Promise on window so an in-flight prefetch is reused if the user
// hits "Play" before it finishes.

const pako = require('./pako.min.js');

declare global {
    interface Window {
        __jsdWasmModulePromise?: Promise<WebAssembly.Module>;
    }
}

const WASM_URL = '/static/jsd3.wasm.gz';

function shouldSkipPrefetch(): boolean {
    if (typeof navigator === 'undefined') return true;
    const conn: any = (navigator as any).connection;
    if (!conn) return false;
    if (conn.saveData) return true;
    const t = conn.effectiveType;
    if (t === 'slow-2g' || t === '2g') return true;
    return false;
}

async function compileWasm(): Promise<WebAssembly.Module> {
    const resp = await fetch(WASM_URL, { credentials: 'omit' });
    if (!resp.ok) throw new Error(`wasm fetch failed: ${resp.status}`);
    const gz = await resp.arrayBuffer();
    let buffer = pako.ungzip(new Uint8Array(gz));
    if (buffer[0] === 0x1f && buffer[1] === 0x8b) {
        buffer = pako.ungzip(buffer);
    }
    return await WebAssembly.compile(buffer);
}

export function prefetchWasm(): Promise<WebAssembly.Module> | null {
    if (typeof window === 'undefined') return null;
    if (window.__jsdWasmModulePromise) return window.__jsdWasmModulePromise;
    if (shouldSkipPrefetch()) return null;

    const start = () => {
        window.__jsdWasmModulePromise = compileWasm().catch((err) => {
            console.warn('wasm prefetch failed, will load on demand', err);
            delete window.__jsdWasmModulePromise;
            throw err;
        });
    };

    const ric: any = (window as any).requestIdleCallback;
    if (typeof ric === 'function') {
        ric(start, { timeout: 2000 });
    } else {
        setTimeout(start, 200);
    }
    return window.__jsdWasmModulePromise ?? null;
}
